import request from '../../utils/request';

// 首页--获取发起申请数，新增客户数，新绑档案数
export function getCusStatistic(params,authorization){
  return request({
    url: '/api/statistic/getCusStatistic',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  })
}
// 首页--获取客户添加表格数据
export function getCusAddDetail(params,authorization,isloading){
  return request({
    url: '/api/statistic/getCusAddDetail',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 首页--获取员工给客户统计图表数据
export function getEmpCusDetail(params,authorization,isloading){
  return request({
    url: '/api/statistic/getEmpCusDetail',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 首页--获取员工排行
export function getEmpRank(params,authorization,isloading){
  return request({
    url: '/api/statistic/getEmpRank',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}

// 首页--客户联系统计
export function getCusChatDetail(params,authorization,isloading){
  return request({
    url: '/api/statistic/getCusChatDetail',
    method: 'post',
    data: params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 首页--获取聊天总数，发送消息数量，平局首次回复时
export function getEmpChatCusStatistic(params,authorization,isloading){
  return request({
    url: '/api/statistic/getEmpChatCusStatistic',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 首页--获取累计绑定客户数，绑定答案数，客户总数
export function getCusHistoryData(authorization,isloading){
  return request({
    url: '/api/statistic/getCusHistoryData',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 首页  获取字段设置
export function getFieldData(authorization,isloading){
  return request({
    url: '/api/home/field',
    method: 'get',
    headers: {
      "authorization": authorization
    }
  },isloading)
}

// 员工群聊概况
export function getgroupChatData(params,authorization,isloading){
  return request({
    url: '/api/statistic/group_chat/emp',
    method: 'post',
    data:params,
    headers: {
      "authorization": authorization
    }
  },isloading)
}
// 群聊趋势图
export function getnewGroupChatData(params,authorization){
  return request({
    url: '/api/statistic/group_chat/trend',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  })
}
// 更新看板是否显示
export function updateField(row,authorization){
  return request({
    url: `/api/home/field/${row.fieldId}?isShow=${row.isShow}`,
    method: 'put',
    headers: {
      "authorization": authorization
    }
  })
}

// 获取头部看板数据
export function getGroupChatDatas(params,authorization){
  return request({
    url: '/api/statistic/group_chat/data',
    method: 'get',
    params,
    headers: {
      "authorization": authorization
    }
  })
}
